<!-- eslint-disable vuejs-accessibility/no-autofocus -->
<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <input
    v-bind="computedAttrs"
    v-model="localValue"
    :class="computedClass"
    @change="onChange"
    @input="onInput"
    @blur="onBlur"
    @focus="onFocus"
  >
</template>

<script>

const TYPES = [
  'text',
  'password',
  'email',
  'number',
  'url',
  'tel',
  'search',
  'range',
  'color',
  'date',
  'time',
  'datetime',
  'datetime-local',
  'month',
  'week'
]

export default {
  name: 'BFormInput',
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    value: {
      type: [String, Number],
      default: null
    },
    type: {
      type: String,
      default: 'text',
      validator: (value) => TYPES.includes(value)
    },
    plaintext: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    id: {
      type: String,
      default: null
    },
    list: {
      type: String,
      default: null
    },
    min: {
      type: [String, Number],
      default: null
    },
    max: {
      type: [String, Number],
      default: null
    },
    step: {
      type: [String, Number],
      default: null
    },
    state: {
      type: Boolean,
      default: null
    },
    class: {
      type: String,
      default: null
    },
    form: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  emits: ['update:modelValue', 'change', 'input', 'blur', 'focus'],
  data() {
    return {
      localValue: this.modelValue || this.value || this.min
    }
  },
  computed: {
    computedClass() {
      const { plaintext, type } = this
      const isRange = type === 'range'
      const isColor = type === 'color'

      return [
        {
          'custom-range': isRange,
          'form-control-plaintext': plaintext && !isRange && !isColor,
          'form-control': isColor || (!plaintext && !isRange)
        },
        this.size ? `form-control-${this.size}` : null,
        this.state === true ? 'is-valid' : this.state === false ? 'is-invalid' : null,
        this.class
      ]
    },
    computedAttrs() {
      const { type, name, form, disabled, placeholder, required, min, max, step, id } = this

      return {
        id,
        name,
        form,
        type,
        disabled,
        placeholder,
        required,
        autocomplete: this.autocomplete || null,
        readonly: this.readonly || this.plaintext,
        min,
        max,
        step,
        list: type !== 'password' ? this.list : null,
        'aria-required': required ? 'true' : null
      }
    }
  },
  watch: {
    modelValue(n, o) {
      if (n !== o) {
        this.localValue = n
      }
    },
    value(n, o) {
      if (n !== o) {
        this.localValue = n
      }
    }
  },
  methods: {
    formatValue(e) {
      if (this.type === 'number' || this.type === 'range') {
        return e.target.valueAsNumber
      }
      return e.target.value
    },
    doModelUpdate(value) {
      this.$emit('update:modelValue', value)
    },
    onChange(e) {
      this.doModelUpdate(this.formatValue(e))
      this.$emit('change', this.formatValue(e))
    },
    onInput(e) {
      this.doModelUpdate(this.formatValue(e))
      this.$emit('input', this.formatValue(e))
    },
    onBlur(e) {
      this.$emit('blur', this.formatValue(e))
    },
    onFocus(e) {
      this.$emit('focus', this.formatValue(e))
    },
    focus() {
      this.$el.focus()
    },
    blur() {
      this.$el.blur()
    }

  }
}
</script>
